var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "30px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-icon",
                      staticStyle: { background: "#409EFF" },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-microphone",
                        staticStyle: { "font-size": "32px", color: "white" },
                      }),
                    ]
                  ),
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-title" }, [
                      _vm._v("Total Active Users"),
                    ]),
                    _c("div", { staticClass: "stat-value" }, [
                      _vm._v(_vm._s(_vm.statistics.totalActiveUsers)),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-icon",
                      staticStyle: { background: "#67C23A" },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-shopping-bag-1",
                        staticStyle: { "font-size": "32px", color: "white" },
                      }),
                    ]
                  ),
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-title" }, [
                      _vm._v("Pre-order Users"),
                    ]),
                    _c("div", { staticClass: "stat-value" }, [
                      _vm._v(_vm._s(_vm.statistics.preOrderUsers)),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-icon",
                      staticStyle: { background: "#E6A23C" },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-warning",
                        staticStyle: { "font-size": "32px", color: "white" },
                      }),
                    ]
                  ),
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-title" }, [
                      _vm._v("Expiring in 30 Days"),
                    ]),
                    _c("div", { staticClass: "stat-value" }, [
                      _vm._v(_vm._s(_vm.statistics.expiringIn30Days)),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-icon",
                      staticStyle: { background: "#F56C6C" },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-time",
                        staticStyle: { "font-size": "32px", color: "white" },
                      }),
                    ]
                  ),
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-title" }, [
                      _vm._v("Expiring in 90 Days"),
                    ]),
                    _c("div", { staticClass: "stat-value" }, [
                      _vm._v(_vm._s(_vm.statistics.expiringIn90Days)),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "150px" },
              attrs: { placeholder: "Expiry Filter" },
              on: { change: _vm.loadExpiringUsers },
              model: {
                value: _vm.daysFilter,
                callback: function ($$v) {
                  _vm.daysFilter = $$v
                },
                expression: "daysFilter",
              },
            },
            [
              _c("el-option", { attrs: { label: "30 Days", value: 30 } }),
              _c("el-option", { attrs: { label: "60 Days", value: 60 } }),
              _c("el-option", { attrs: { label: "90 Days", value: 90 } }),
              _c("el-option", { attrs: { label: "180 Days", value: 180 } }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.loadExpiringUsers },
            },
            [_vm._v(" Search ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-download" },
              on: { click: _vm.exportExcel },
            },
            [_vm._v(" Export Excel ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-plus" },
              on: { click: _vm.handleGrantNew },
            },
            [_vm._v(" Grant VA Rights ")]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [
              _c("strong", [
                _vm._v("Users with Expiring Voice Assistant Access"),
              ]),
            ]),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.expiringUsers,
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "User ID", align: "center", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_c("span", [_vm._v(_vm._s(row.userId))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Expiry Date", align: "center", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatDate(row.entitlement.endDate)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Days Remaining",
                  align: "center",
                  width: "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getDaysTag(row.daysRemaining),
                              size: "medium",
                            },
                          },
                          [_vm._v(" " + _vm._s(row.daysRemaining) + " days ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Source", align: "center", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getSourceTag(
                                row.entitlement.sourceType
                              ),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(row.entitlement.sourceType) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Source Reference",
                  align: "center",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(row.entitlement.sourceReference || "N/A") +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Actions",
                  align: "center",
                  width: "250",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              icon: "el-icon-view",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleViewStatus(row)
                              },
                            },
                          },
                          [_vm._v(" View Status ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "success",
                              icon: "el-icon-plus",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleExtend(row)
                              },
                            },
                          },
                          [_vm._v(" Extend ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "danger",
                              icon: "el-icon-delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleRevoke(row)
                              },
                            },
                          },
                          [_vm._v(" Revoke ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: {
              total: _vm.total,
              page: _vm.listQuery.page,
              limit: _vm.listQuery.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.listQuery, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.listQuery, "limit", $event)
              },
              pagination: _vm.loadExpiringUsers,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Voice Assistant Status",
            visible: _vm.dialogStatusVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogStatusVisible = $event
            },
          },
        },
        [
          _c(
            "el-descriptions",
            { attrs: { column: 2, border: "" } },
            [
              _c(
                "el-descriptions-item",
                { attrs: { label: "User ID", span: 2 } },
                [_vm._v(_vm._s(_vm.statusData.userId))]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Has Access" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.statusData.hasAccess ? "success" : "danger",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.statusData.hasAccess ? "Yes" : "No") +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "Expiry Date" } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.statusData.expiryInfo?.expiryDate
                        ? _vm.formatDate(_vm.statusData.expiryInfo.expiryDate)
                        : "N/A"
                    ) +
                    " "
                ),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Days Remaining" } },
                [
                  _vm.statusData.expiryInfo
                    ? _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getDaysTag(
                              _vm.statusData.expiryInfo.daysRemaining
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.statusData.expiryInfo.daysRemaining) +
                              " days "
                          ),
                        ]
                      )
                    : _c("span", [_vm._v("N/A")]),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Expiring Soon" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.statusData.expiryInfo?.isExpiringSoon
                          ? "warning"
                          : "success",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.statusData.expiryInfo?.isExpiringSoon
                              ? "Yes"
                              : "No"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-divider", [_vm._v("Entitlements")]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.statusData.entitlements, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "Source", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getSourceTag(row.sourceType),
                              size: "small",
                            },
                          },
                          [_vm._v(" " + _vm._s(row.sourceType) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Start", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.formatDate(row.startDate)) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "End", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              row.endDate
                                ? _vm.formatDate(row.endDate)
                                : "Permanent"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogStatusVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Extend Voice Assistant",
            visible: _vm.dialogExtendVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogExtendVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "extendForm",
              attrs: {
                model: _vm.extendData,
                rules: _vm.extendRules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "User ID" } },
                [_c("el-tag", [_vm._v(_vm._s(_vm.extendData.userId))])],
                1
              ),
              _c("el-form-item", { attrs: { label: "Current Expiry" } }, [
                _vm._v(" " + _vm._s(_vm.extendData.currentExpiry) + " "),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: { label: "Extension Period", prop: "extensionMonths" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "Select period" },
                      model: {
                        value: _vm.extendData.extensionMonths,
                        callback: function ($$v) {
                          _vm.$set(_vm.extendData, "extensionMonths", $$v)
                        },
                        expression: "extendData.extensionMonths",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "1 Month", value: 1 },
                      }),
                      _c("el-option", {
                        attrs: { label: "3 Months", value: 3 },
                      }),
                      _c("el-option", {
                        attrs: { label: "6 Months", value: 6 },
                      }),
                      _c("el-option", {
                        attrs: { label: "1 Year", value: 12 },
                      }),
                      _c("el-option", {
                        attrs: { label: "2 Years", value: 24 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "New Expiry" } },
                [
                  _c("el-tag", { attrs: { type: "success" } }, [
                    _vm._v(_vm._s(_vm.calculateNewExpiry())),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Reason", prop: "reason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "Reason for extension",
                    },
                    model: {
                      value: _vm.extendData.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.extendData, "reason", $$v)
                      },
                      expression: "extendData.reason",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-alert",
                {
                  attrs: {
                    title: "Send notification to user",
                    type: "info",
                    closable: false,
                  },
                },
                [
                  _vm._v(
                    " User will receive a notification about the extension. "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogExtendVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmExtend },
                },
                [_vm._v("Extend")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Grant Voice Assistant Rights",
            visible: _vm.dialogGrantVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogGrantVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "grantForm",
              attrs: {
                model: _vm.grantData,
                rules: _vm.grantRules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Select User", prop: "userId" } },
                [
                  _c("user-search", {
                    attrs: { placeholder: "Search by name, email or phone..." },
                    on: { change: _vm.handleUserSelected },
                    model: {
                      value: _vm.grantData.userId,
                      callback: function ($$v) {
                        _vm.$set(_vm.grantData, "userId", $$v)
                      },
                      expression: "grantData.userId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Duration", prop: "durationMonths" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "Select duration" },
                      model: {
                        value: _vm.grantData.durationMonths,
                        callback: function ($$v) {
                          _vm.$set(_vm.grantData, "durationMonths", $$v)
                        },
                        expression: "grantData.durationMonths",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "1 Month", value: 1 },
                      }),
                      _c("el-option", {
                        attrs: { label: "3 Months", value: 3 },
                      }),
                      _c("el-option", {
                        attrs: { label: "6 Months", value: 6 },
                      }),
                      _c("el-option", {
                        attrs: { label: "1 Year", value: 12 },
                      }),
                      _c("el-option", {
                        attrs: { label: "2 Years", value: 24 },
                      }),
                      _c("el-option", {
                        attrs: { label: "3 Years", value: 36 },
                      }),
                      _c("el-option", {
                        attrs: { label: "4 Years", value: 48 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Device Serial (Optional)" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Link to device serial number" },
                    model: {
                      value: _vm.grantData.deviceSerialNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.grantData, "deviceSerialNumber", $$v)
                      },
                      expression: "grantData.deviceSerialNumber",
                    },
                  }),
                  _c(
                    "span",
                    { staticStyle: { "font-size": "12px", color: "#909399" } },
                    [_vm._v("Optional: Link VA rights to specific device")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Reason", prop: "reason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "Reason for granting VA rights",
                    },
                    model: {
                      value: _vm.grantData.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.grantData, "reason", $$v)
                      },
                      expression: "grantData.reason",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-alert",
                {
                  attrs: {
                    title: "This will grant NEW Voice Assistant rights",
                    type: "warning",
                    closable: false,
                  },
                },
                [
                  _vm._v(
                    ' Make sure the user does not already have active VA rights. Use "Extend" instead to extend existing rights. '
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogGrantVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmGrant } },
                [_vm._v("Grant VA Rights")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }